import { application } from "../application"

import AjaxContentController from "../ajax_content_controller"
application.register("ajax-content", AjaxContentController)

import AnchorController from "../anchor_controller"
application.register("anchor", AnchorController)

import FavoriteController from "../favorite_controller"
application.register("favorite", FavoriteController)

import FooterAdController from "../footer_ad_controller"
application.register("footer-ad", FooterAdController)

import RecentlyStocksController from "../recently_stocks_controller"
application.register("recently-stocks", RecentlyStocksController)

import ScrollToTopController from "../scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import JsLazyLoadingController from "../js_lazy_loading_controller"
application.register("js-lazy-loading", JsLazyLoadingController)

import TomSelectController from "../tom_select_controller"
application.register("tom-select", TomSelectController)
